// NOTE: value cannot be the integer 0, must be string to work with Select component
const getPriorityOptions = () => {
  return [
    { value: "0", label: "Low" },
    { value: "1", label: "Medium" },
    { value: "2", label: "High" },
  ]
}

const getPriority = (index) => {
  let priority = ""
  switch (index) {
    case (2): priority = "High"; break;
    case (1): priority = "Medium"; break;
    case (0): priority = "Low"; break;
    default: priority = ""
  }
  return priority
}

export {
  getPriorityOptions,
  getPriority,
}